var exports = {
  "kL": "x04b3a21e--338a26--container",
  "Dk": "x04b3a21e--338a26--carousel",
  "M6": "x04b3a21e--338a26--slide",
};

module.exports = exports;
